export default __webpack_public_path__ + "static/banner-blue-circle-667297e316cbf60024e25ec9cd815060.png";